import { ConfigProvider } from "antd";
import ruRU from "antd/locale/ru_RU";
import { authEvents } from "events/authEvents";
import { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "router";
import style from "variables.module.scss";

import { useAppDispatch } from "app/hooks";

import { setFirstInteract } from "storeSlices/appSettings";

function App() {
  const dispatch = useAppDispatch();

  const [hasUserInteracted, setHasUserInteracted] = useState(false);

  // Обрабатываем выход из системы
  useEffect(() => {
    // Подписываемся на событие
    const unsubscribe = authEvents.onUnauthorized(() => {
      router.navigate("/logout");
    });

    return unsubscribe;
  }, []);

  // Обрабатываем бездействие пользователя на сайте
  useEffect(() => {
    // Функция, которая отмечает первое взаимодействие
    const handleFirstInteraction = () => {
      if (!hasUserInteracted) {
        // console.log("Первое взаимодействие пользователя зафиксировано!");
        setHasUserInteracted(true);
        dispatch(setFirstInteract(true));
      }
    };

    // Отслеживаем различные типы событий взаимодействия
    const events = ["click", "touchstart", "contextmenu", "mousedown"];

    events.forEach((event) => {
      window.addEventListener(event, handleFirstInteraction, { once: true }); // { once: true } - выполнится только один раз!
    });

    // Очистка
    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, handleFirstInteraction);
      });
    };
  }, [hasUserInteracted, dispatch]); // Зависимость от hasUserInteracted для корректной работы

  return (
    <ConfigProvider
      wave={{ disabled: true }}
      locale={ruRU}
      theme={{
        token: {
          fontFamily: style.fontFamily,
          colorPrimary: style.greenColor,
          colorTextBase: style.mainTextColor,
          colorError: style.colorError,
          colorErrorBg: style.lightColorError,
          colorWarning: style.yellowColor,
          colorWarningBg: style.lightYellowColor,
          colorInfo: style.blueColor,
          colorInfoBg: style.lightBlueColor,
          colorBorderSecondary: style.borderColor,
          borderRadiusLG: 18,
        },
        components: {
          Table: {
            borderColor: style.borderColor,
          },
        },
      }}
    >
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}

export default App;
